import XLSX from 'xlsx'
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

function Botones({ data }) {




  const handleClick = () => {
    const finalData = data.map(usr => {
      const finalUser = {
        Alta: usr.fechaCreacion?.split("T")[0],
        Codigo: usr.identificador,
        Nombre: usr.nombreCompleto,
        Telefono: usr.telefono,
        Email: usr.email,
        Dni: usr.dni,
        "Preferencia de pago": usr.preferenciaPago,
        Direccion: `${usr.calle} ${usr.numero} ${usr.dpto} ${usr.referencias}`.trim(),
        "Saldo Efectivo": parseFloat(usr.saldoEfectivo),
        "Saldo Credito": parseFloat(usr.saldoCredito),
        "Saldo nota de credito": parseFloat(usr.saldoNotaCredito),
        "Total Productos": parseFloat(usr.productosTotales),
        "Sumatoria precios": parseFloat(usr.totalEnProductos),
      }

      return finalUser;
    });

    // Crear un libro de Excel y convertir el array en una hoja de cálculo
    const libro = XLSX.utils.book_new();
    const hoja = XLSX.utils.json_to_sheet(finalData);
    XLSX.utils.book_append_sheet(libro, hoja, 'Usuarios');
    // Generar un archivo de Excel y descargarlo
    XLSX.writeFile(libro, 'usuario.xlsx');
  }

  return (
    <div>
      <Button variant="contained" onClick={handleClick} color="success">Descargar Excel</Button>
    </div>
  );
}
Botones.propTypes = {
  data: PropTypes.array,
}
export default Botones